import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import _ from 'lodash';
import moment from 'moment';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import {
  UPDATE_STATUS,
  UPDATE_ACCOUNT,
  UPDATE_FILTER_CRITERIA,
  UPDATE_DATE_INTERVAL,
  UPDATE_FROM_DATE,
  UPDATE_TO_DATE,
  SET_PAYMENT_HISTORY_SME_LIST,
  SET_PAYMENT_HISTORY_SME_ERROR,
  GET_SME_PAYMENT_HISTORY_LIST,
  SHOW_MORE_PAYMENT_HISTORY_SME,
  UPDATE_SORT_ORDER,
  UPDATE_SEARCH,
  RESET_PAYMENT_HISTORY_SME,
  SET_PAYMENT_HISTORY_CREATOR_LIST,
  SET_PAYMENT_HISTORY_CREATOR_ERROR,
} from '../actions/PaymentsHistorySMEActionCreator';
import {
  SET_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY,
  CLEAR_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY,
} from '../actions/PaymentStatusActionCreator';
import StringConstants from '../constants/StringConstants';
import {
  getPaymentHistorySME,
  getPaymentHistoryForCreator,
} from '../utils/PaymentsHistorySMEApiUtils';
import {
  createGetPaymentHistoryRequest,
  createGetPaymentHistoryRequestForCreator,
} from '../parsers/PaymentHistoryParser';

import AccountsStore from './AccountsStore';
import envConfig from '../../static/config';

const pageSize = StringConstants.TRANSACTION_LIMIT;
let hasError = false;
let error = null;
let paymentHistoryList = [];
let isLoading = false;

let isGetCreatorHistoryInProgress = false;
let isGetAllHistoryInProgress = false;

const setFilterCriterias = () => {
  const defaultDateInterval = envConfig.isLcvEnabled ? 'week' : 'month';
  return {
    status: 'All',
    dateInterval: `1 ${defaultDateInterval}`,
    fromDate: moment().subtract(1, `${defaultDateInterval}`),
    numberToDisplay: pageSize,
    accountId: StringConstants.ALL_ACCOUNTS,
    toDate: moment(),
    sortBy: 'createdDateRaw',
    sortOrder: 'desc',
    search: '',
    isCustomDateInterval: false,
  };
};
let filterCriteria = setFilterCriterias();

const CAPABILTY_TRANSACTION_READ = '/account/transactions/read';

class PaymentHistorySMEStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  reset() {
    paymentHistoryList = [];
    hasError = false;
    error = null;
    filterCriteria = setFilterCriterias();
  }
  getFilterCriteria() {
    return filterCriteria;
  }
  hasError() {
    return hasError;
  }
  getError() {
    return error;
  }
  isLoading() {
    return isLoading;
  }
  isShowMore() {
    return filterCriteria.numberToDisplay < paymentHistoryList.length;
  }
  getFilteredByStatus(paymentHistoryList, status) {
    return _.filter(paymentHistoryList, (paymentHistory) => {
      if (status.toUpperCase() !== 'ALL') {
        return (
          paymentHistory.status === status ||
          this.checkBatchStatus(paymentHistory, status)
        );
      }
      return true;
    });
  }
  checkBatchStatus(paymentHistory, status) {
    if (
      paymentHistory.hasOwnProperty('children') &&
      _.some(paymentHistory.children, { status })
    )
      return true;
    return false;
  }
  paymentHistoryList() {
    return paymentHistoryList;
  }
  getAccountIds(selectedAccount) {
    const allAccounts = AccountsStore.getAllAccountsForPaymentsHistory();
    const accountIdsForCreatorHistory = [];
    const accountIdsForAllHistory = [];
    if (selectedAccount === StringConstants.ALL_ACCOUNTS) {
      allAccounts.forEach((account) => {
        if (account.actionsAvailable[CAPABILTY_TRANSACTION_READ]) {
          accountIdsForAllHistory.push(account.id);
        } else {
          accountIdsForCreatorHistory.push(account.id);
        }
      });
      return { accountIdsForCreatorHistory, accountIdsForAllHistory };
    }
    const accountDetails = AccountsStore.getAccountDetail(selectedAccount);
    if (accountDetails.actionsAvailable[CAPABILTY_TRANSACTION_READ]) {
      accountIdsForAllHistory.push(selectedAccount);
    } else {
      accountIdsForCreatorHistory.push(selectedAccount);
    }
    return {
      accountIdsForCreatorHistory,
      accountIdsForAllHistory,
    };
  }
  callApiToGetPaymentHistory(filterCriteria) {
    isLoading = true;
    hasError = false;
    error = null;
    paymentHistoryList = [];
    const { accountIdsForCreatorHistory, accountIdsForAllHistory } =
      this.getAccountIds(filterCriteria.accountId);
    isGetAllHistoryInProgress = !!accountIdsForAllHistory.length;
    isGetCreatorHistoryInProgress = !!accountIdsForCreatorHistory.length;

    accountIdsForCreatorHistory.length &&
      getPaymentHistoryForCreator(
        createGetPaymentHistoryRequestForCreator(
          filterCriteria,
          accountIdsForCreatorHistory
        )
      );
    accountIdsForAllHistory.length &&
      getPaymentHistorySME(
        createGetPaymentHistoryRequest(filterCriteria, accountIdsForAllHistory)
      );
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case AppConstants.LOGOUT_USER:
        this.reset();
        break;
      case GET_SME_PAYMENT_HISTORY_LIST:
        this.callApiToGetPaymentHistory(filterCriteria);
        this.emitChange();
        break;
      case UPDATE_FROM_DATE:
        filterCriteria.fromDate = actionData;
        this.callApiToGetPaymentHistory(filterCriteria);
        this.emitChange();
        break;
      case UPDATE_TO_DATE:
        filterCriteria.toDate = actionData;
        this.callApiToGetPaymentHistory(filterCriteria);
        this.emitChange();
        break;
      case UPDATE_DATE_INTERVAL:
        filterCriteria.dateInterval = actionData.dateInterval;
        filterCriteria.isCustomDateInterval = actionData.isCustomDateInterval;
        filterCriteria.fromDate = actionData.fromDate;
        this.callApiToGetPaymentHistory(filterCriteria);
        this.emitChange();
        break;
      case SET_PAYMENT_HISTORY_SME_LIST:
        isGetAllHistoryInProgress = false;
        paymentHistoryList = paymentHistoryList.concat(actionData);
        isLoading = false;
        hasError = false;
        error = null;
        if (!isGetCreatorHistoryInProgress) {
          this.emitChange();
        }
        break;
      case SET_PAYMENT_HISTORY_SME_ERROR:
        isLoading = false;
        hasError = true;
        isGetAllHistoryInProgress = false;
        error = actionData.error;
        paymentHistoryList = [];
        if (!isGetCreatorHistoryInProgress) {
          this.emitChange();
        }
        break;
      case SET_PAYMENT_HISTORY_CREATOR_LIST:
        isGetCreatorHistoryInProgress = false;
        paymentHistoryList = paymentHistoryList.concat(actionData);
        isLoading = false;
        hasError = false;
        error = null;
        if (!isGetAllHistoryInProgress) {
          this.emitChange();
        }
        break;
      case SET_PAYMENT_HISTORY_CREATOR_ERROR:
        isLoading = false;
        hasError = true;
        isGetCreatorHistoryInProgress = false;
        error = actionData.error;
        paymentHistoryList = [];
        if (!isGetAllHistoryInProgress) {
          this.emitChange();
        }
        break;
      case UPDATE_STATUS:
        filterCriteria.status = actionData;
        filterCriteria.numberToDisplay = pageSize;
        this.callApiToGetPaymentHistory(filterCriteria);
        this.emitChange();
        break;
      case UPDATE_ACCOUNT:
        filterCriteria.accountId = actionData;
        filterCriteria.numberToDisplay = pageSize;
        this.callApiToGetPaymentHistory(filterCriteria);
        this.emitChange();
        break;
      case UPDATE_FILTER_CRITERIA:
        filterCriteria = actionData;
        this.emitChange();
        break;
      case SHOW_MORE_PAYMENT_HISTORY_SME:
        filterCriteria.numberToDisplay += pageSize;
        this.emitChange();
        break;
      case UPDATE_SORT_ORDER:
        filterCriteria = {
          ...filterCriteria,
          sortBy: actionData.sortBy,
          sortOrder: actionData.sortOrder,
        };
        this.emitChange();
        break;
      case UPDATE_SEARCH:
        filterCriteria = { ...filterCriteria, search: actionData };
        this.emitChange();
        break;
      case SET_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY:
        filterCriteria.accountId = actionData;
        this.emitChange();
        break;
      case CLEAR_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY:
        filterCriteria.accountId = StringConstants.ALL_ACCOUNTS;
        this.emitChange();
        break;
      case RESET_PAYMENT_HISTORY_SME:
        this.reset();
        this.emitChange();
        break;
      default:
        break;
    }
  }
}
export default new PaymentHistorySMEStore();
